import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Wysiwyg from '../Wysiwyg';

import styles from './InfoBlock.module.scss';

const InfoBlock = ({ title, text, backgroundColor }) => {
    const blockClasses = classNames(styles['InfoBlock'], {
        [styles[`InfoBlock--Green`]]: backgroundColor === 'green',
        [styles[`InfoBlock--Blue`]]: backgroundColor === 'blue',
    });

    return (
        <div className={blockClasses}>
            <div className={styles['InfoBlock__Container']}>
                <div className={styles['InfoBlock__ContainerInner']}>
                    {title && (
                        <h2 className={styles['InfoBlock__Title']}>{title}</h2>
                    )}
                    {text && <Wysiwyg modifier={'InfoBlock'} html={text} />}
                </div>
            </div>
        </div>
    );
};

InfoBlock.propTypes = {
    title: PropTypes.string,
    text: PropTypes.string,
    useImageBackground: PropTypes.bool,
};

InfoBlock.defaultProps = {
    title: '',
    text: '',
    useImageBackground: false,
};

export default InfoBlock;
